import clsx from 'clsx';
import { useEffect, useState } from 'react';
import useBoundStore from 'store';
import Button from 'components/button';
import styles from './styles.module.scss';

export type ToastParams = {
  show: boolean;
  message: string;
  dismissesIn: number;
  dissmissLabel: string;
  onDismissClick?: () => void;
};

const Toast: React.FC = () => {
  const dismissToast = useBoundStore((s) => s.dismissToast);
  const toastParams = useBoundStore((s) => s.toastParams);
  const { show, message, dismissesIn, onDismissClick, dissmissLabel } = toastParams;

  const [timeLeft, setTimeLeft] = useState(toastParams.dismissesIn);

  useEffect(() => {
    const { show, dismissesIn } = toastParams;

    if (show) {
      setTimeLeft(dismissesIn);
      const interval = setInterval(
        () =>
          setTimeLeft((t) => {
            const next = t - 1;
            return next < 0 ? t : next;
          }),
        1000,
      );

      const timeout = setTimeout(dismissToast, dismissesIn * 1000);
      return () => {
        clearTimeout(timeout);
        clearInterval(interval);

        // Чтобы анимация не скакала при следующем открытии тоста
        setTimeLeft(dismissesIn);
      };
    }
  }, [toastParams, dismissToast]);

  const handleDismiss = () => {
    onDismissClick?.();
    dismissToast();
  };

  return (
    <div className={clsx(styles.container, show && styles.containerShow)}>
      <div className={styles.message}>{message}</div>
      <Button
        className={styles.button}
        variant='gray'
        label={dissmissLabel}
        onClick={handleDismiss}
      />
      <span className={styles.progress} style={{ width: `${(timeLeft / dismissesIn) * 100}%` }} />
    </div>
  );
};

export default Toast;
